import React from 'react';

const ProductModal = ({ product, onClose }) => {
  // const getDiscountPercent = (price, originalPrice) => {
  //   return Math.round(((originalPrice - price) / originalPrice) * 100);
  // };

  const handleOrderClick = () => {
    onClose();
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="product-modal-overlay" onClick={onClose}>
      <div className="product-modal" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close-btn" onClick={onClose}>×</button>
        
        <div className="modal-content">
          <div className="modal-image">
            <img src={product.image} alt={product.name} />
            {/* {product.badge && (
              <span className={`product-badge ${product.badge.includes('%') ? 'discount' : ''}`}>
                {product.badge}
              </span>
            )} */}
          </div>

          <div className="modal-info">
            <h2>{product.name}</h2>
            <p className="modal-description">{product.fullDescription}</p>
            
            {/* <div className="modal-price">
              {product.originalPrice > product.price ? (
                <>
                  <span className="current-price">{product.price} </span>
                  <span className="original-price">{product.originalPrice} </span>
                  <span className="discount-percent">
                    -{getDiscountPercent(product.price, product.originalPrice)}%
                  </span>
                </>
              ) : (
                <span className="current-price">{product.price} </span>
              )}
            </div> */}

            <div className="product-features">
              <h3>Особливості:</h3>
              <ul>
                {product.features.map((feature, index) => (
                  <li key={index}>✓ {feature}</li>
                ))}
              </ul>
            </div>

            <div className="product-usage">
              <h3>Спосіб застосування:</h3>
              <p>{product.usage}</p>
            </div>

            <div className="modal-actions">
              <button className="contact-btn" onClick={handleOrderClick}>
                Замовити
              </button>
              <button className="close-btn" onClick={onClose}>
                Закрити
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductModal;